import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
 
    },
    getters: {
    
    },
    mutations: {
      



    },
    actions: {
        async copy_schema({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
              
                const rsp = await axios.post(ApiUrl.schema.copy, postData);
                if (rsp && rsp.data) {
                    //commit('setSpyReportList', rsp.data);
                    handle && handle(rsp.data.result);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async to_public({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
             
                const rsp = await axios.post(ApiUrl.schema.topublic, postData);
                if (rsp && rsp.data) {
                    //commit('setSpyReportList', rsp.data);
                    handle && handle(rsp.data.result);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async delete_schema({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
             
                const rsp = await axios.post(ApiUrl.schema.delete, postData);
                if (rsp && rsp.data) {
                    //commit('setSpyReportList', rsp.data);
                    handle && handle(rsp.data.result);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async get_schema_list({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.get(ApiUrl.schema.list, postData);
                if (rsp && rsp.data) {
                    //commit('setSpyReportList', rsp.data);
                    handle && handle(rsp.data.result);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },

        async get_my_schema_list({ commit }, { postData, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.schema.myschema, postData);
                if (rsp && rsp.data) {
                    //commit('setSpyReportList', rsp.data);
                    handle && handle(rsp.data.result);
                }

            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
       
    }
}